import {SupplierRange} from "../../types/supplierRange";

export function findRangeFromProductCode(ranges: SupplierRange[], code: string) : SupplierRange | null {
    
    const rangeMatches = ranges.filter(range => code.toLowerCase().startsWith(range.prefix.toLowerCase()));
    const range = rangeMatches.length > 0 ? rangeMatches.sort((a, b) => b.prefix.length - a.prefix.length)[0] : null;

    return range;
}